import { render, staticRenderFns } from "./WebGameManagement.vue?vue&type=template&id=668cdcc0&scoped=true"
import script from "./WebGameManagement.vue?vue&type=script&lang=js"
export * from "./WebGameManagement.vue?vue&type=script&lang=js"
import style0 from "./WebGameManagement.vue?vue&type=style&index=0&id=668cdcc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668cdcc0",
  null
  
)

export default component.exports